import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-aeab1582"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "loading-bg" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loading-header-mobile" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Trailer Solutions")
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loading-content" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "spinner" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "loader" })
  ])
], -1))
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["loading-container", _ctx.isFullScreen ? 'full-screen' : ''])
    }, _hoisted_4, 2)
  ]))
}